var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7062 4.70615C11.0968 4.31553 11.0968 3.68115 10.7062 3.29053C10.3155 2.8999 9.68115 2.8999 9.29053 3.29053L5.9999 6.58428L2.70615 3.29365C2.31553 2.90303 1.68115 2.90303 1.29053 3.29365C0.899902 3.68428 0.899902 4.31865 1.29053 4.70928L4.58428 7.9999L1.29365 11.2937C0.903027 11.6843 0.903027 12.3187 1.29365 12.7093C1.68428 13.0999 2.31865 13.0999 2.70928 12.7093L5.9999 9.41553L9.29365 12.7062C9.68428 13.0968 10.3187 13.0968 10.7093 12.7062C11.0999 12.3155 11.0999 11.6812 10.7093 11.2905L7.41553 7.9999L10.7062 4.70615Z",
    fill: "#172554"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClose);
export default __webpack_public_path__ + "static/media/ic_close.1e6b974ded47514fb31af0b24f99b354.svg";
export { ForwardRef as ReactComponent };